import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MdAdd } from 'react-icons/md';
import { exportToExcel } from '../../lib/xlsx/xlsxLibrary';

import { conveyorWeightTotal } from './StructureList';

const StructureListActionButtons = () => {
    const project = useSelector(state => state.project.project);
    const conveyors = useSelector(state => state.conveyors.conveyors);
    const user = useSelector(state => state.user.user);

    if (!conveyors) return;

    const ownProject = (user && user._id) === (project && project.user._id);

    /* Excel Export를 위해 structure Data를 가공해야 한다. <- 안할 수는 없나??? */
    const exportData = dataConvert(conveyors);
    const projectName = project?.title;
    const filename = `Structure Weight Table_${projectName}.xlsx`;

    return (
        <StructureListActionButtonsBlock>
            {ownProject && (
                <>
                    <StyledLink to="/write/structure" style={{ visibility: 'hidden' }}>
                        Add Structure
                        <MdAdd />
                    </StyledLink>
                    <StyledButton onClick={() => exportToExcel(exportData, filename)}>
                        Download Excel File(.xlsx)
                    </StyledButton>
                </>
            )}
        </StructureListActionButtonsBlock>
    );
};

export default StructureListActionButtons;

/* =================   Styles   ================== */

const StructureListActionButtonsBlock = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
`;

const StyledLink = styled(Link)`
    padding: 0.25rem 1rem 0.35rem;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: ${palette.orange};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        transition: 0.3s;
    }
`;

const StyledButton = styled.button`
    padding: 0.25rem 1rem 0.35rem;
    border: 1px solid transparent;
    border-radius: 2px;
    background-color: ${palette.gray[6]};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.gray[6]};
        border: 1px solid ${palette.gray[6]};
        transition: 0.3s;
        cursor: pointer;
    }
`;

/* =================   Excel Export   ================== */
const dataConvert = (conveyors) => {
    let data = [];
    conveyors.map((conveyor) => data.push(rowGenerator(conveyor)));
    return data;
};

const rowGenerator = (conveyor) => {
    if (!conveyor.body?.structure) return;

    const { summary } = conveyor.body.structure;
    if (!summary) return;

    return {
        'Conveyor\r\nID': `${conveyor.title}`,
        'Girder': `${summary.girder?.totalWeight || 0}`,
        'PC Panel': `${summary.pcPanel?.totalWeight || 0}`,
        'Gallery': `${summary.gallery?.totalWeight || 0}`,
        'Trestle': `${summary.trestle?.totalWeight || 0}`,
        'Stringer': `${summary.stringer?.totalWeight || 0}`,
        'Walkway': `${summary.walkway?.totalWeight || 0}`,
        'Decking\r\nPlage': `${summary.deckingPlate?.totalWeight || 0}`,
        'Side\r\nCover': `${summary.sideCover?.totalWeight || 0}`,
        'Skirtboard': `${summary.skirtboard?.totalWeight || 0}`,
        'Take-up': `${summary.takeup?.totalWeight || 0}`,
        'Pulley Frame': `${summary.pulleyFrame?.totalWeight || 0}`,
        'Common Bed': `${summary.commonBed?.totalWeight || 0}`,
        'Chute': `${summary.chute?.totalWeight || 0}`,
        'Chute\r\nDamper': `${summary.chuteDamper?.totalWeight || 0}`,
        'Chute\r\nLiner': `${summary.chuteLiner?.totalWeight || 0}`,
        'Shuttle\r\nFrame': `${summary.shuttle?.totalWeight || 0}`,
        'Tripper\r\nFrame': `${summary.tripper?.totalWeight || 0}`,
        'Wheel\r\nAssy': `${summary.wheelAssy?.totalWeight || 0}`,
        'Rail': `${summary.rail?.totalWeight || 0}`,
        'Over-\r\nbridge': `${summary.overbridge?.totalWeight || 0}`,
        'Internal\r\nBelt\r\nCleaner': `${summary.internalBeltCleaner?.totalWeight || 0}`,
        'Safety\r\nCover': `${summary.safetyCover?.totalWeight || 0}`,
        'Anchor\r\nBolt': `${summary.anchorBolt?.totalWeight || 0}`,
        'Total': `${conveyorWeightTotal(summary) || 0}`,
    };
};
